export const STATUS_FILTER_OPTIONS = [
  { label: '全部', value: '' },
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 }
]

export const STATUS_FORM_OPTIONS = [
  { label: '启用', value: 1 },
  { label: '禁用', value: 0 }
]

export const TITLE_MAX_LENGTH = 15
export const SUGGESTION_MAX_LENGTH = 500

export const getDeleteConfirmContent = (title) =>
  `确定要删除审核建议「${title}」吗？`
